const constant = {
  BACKEDN_BASE_URL: process.env.REACT_APP_BASE_URL || "http://localhost:8000/",
  SSO_BASE_URL: process.env.REACT_APP_SSO_BASE_URL || "https://auth.ge3s.org/api/auth",
  SSO_CLIENT_ID: process.env.REACT_APP_SSO_CLIENT_ID || "si-local-client-id-1234",
  DIGITAL_BASE_URL: process.env.REACT_APP_DIGITAL_BASE_URL || "https://digital.ge3s.org",
  IMG_URL: "https://annual-reports-si-tool.s3.ap-south-1.amazonaws.com",
};

export const REGEX_PATTERNS = {
  EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
};

export default constant;
